import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { BranchEndpointService } from '../_services/branch-endpoint.service';
import { CompanyKey, isCompany } from '../company-ids';

export const companyMatch =
  (company: CompanyKey): CanMatchFn =>
  () =>
    inject(BranchEndpointService)
      .load()
      .pipe(
        map((details) => isCompany(company, details?.companyId)),
        catchError(() => of(false)),
      );
